









import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { Locale } from '@/enums/Locale';

@Component({
  components: {},
})
export default class IndexSearch extends Vue {
  selectedLanguage: { value: string; label: string } = this.languages.find((lg) => lg.value === 'nl-BE')!;

  get languages(): Array<{ value: string; label: string }> {
    return Object.values(Locale).map((locale) => ({ value: locale, label: this.$t(`locales.${locale}`).toString() }));
  }

  @Emit('input')
  handleSearch({ target: { value } }: { target: { value: string } }) {
    return value;
  }
}
